import { useEffect, useState } from 'react';
import axios from 'axios';
import Layout from '../components/Layout';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';

import {
  FaUserGraduate,
  FaPlus,
  FaEdit,
  FaTrash,
  FaFileExcel,
  FaSearch
} from 'react-icons/fa';

function Students() {

  const [students, setStudents] = useState([]);
  const [search, setSearch] = useState('');

  const [parentId, setParentId] = useState('');
  const [studentName, setStudentName] = useState('');
  const [className, setClassName] = useState('');
  const [sectionName, setSectionName] = useState('');

  const [editId, setEditId] = useState(null);
  const [isEditing, setIsEditing] = useState(false);

  useEffect(() => {
    fetchStudents();
  }, []);

  const fetchStudents = () => {
    axios
      .get(`${process.env.REACT_APP_API_URL}/students`)
      .then((res) => {
        setStudents(res.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const exportToExcel = () => {

    const worksheet =
      XLSX.utils.json_to_sheet(students);

    const workbook =
      XLSX.utils.book_new();

    XLSX.utils.book_append_sheet(
      workbook,
      worksheet,
      'Students'
    );

    const excelBuffer = XLSX.write(
      workbook,
      {
        bookType: 'xlsx',
        type: 'array'
      }
    );

    const data = new Blob(
      [excelBuffer],
      {
        type:
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      }
    );

    saveAs(data, 'Students.xlsx');

  };

  const clearForm = () => {

    setParentId('');
    setStudentName('');
    setClassName('');
    setSectionName('');
    setEditId(null);
    setIsEditing(false);

  };

  const addStudent = () => {

    axios.post(
      `${process.env.REACT_APP_API_URL}/student`,
      {
        parent_id: parentId,
        student_name: studentName,
        class_name: className,
        section_name: sectionName
      }
    )
    .then(() => {

      alert('Student Added Successfully');

      clearForm();
      fetchStudents();

    })
    .catch((err) => {
      console.log(err);
    });

  };

  const editStudent = (student) => {

    setEditId(student.id);
    setStudentName(student.student_name);
    setClassName(student.class_name);
    setSectionName(student.section_name);

    setIsEditing(true);

    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });

  };

  const updateStudent = () => {

    axios.put(
      `${process.env.REACT_APP_API_URL}/student/${editId}`,
      {
        student_name: studentName,
        class_name: className,
        section_name: sectionName
      }
    )
    .then(() => {

      alert('Student Updated Successfully');

      clearForm();
      fetchStudents();

    })
    .catch((err) => {
      console.log(err);
    });

  };

  const deleteStudent = (id) => {

    if (
      !window.confirm(
        'Delete this student?'
      )
    ) {
      return;
    }

    axios.delete(
      `${process.env.REACT_APP_API_URL}/student/${id}`
    )
    .then(() => {

      alert('Student Deleted');

      fetchStudents();

    })
    .catch((err) => {
      console.log(err);
    });

  };

  return (

    <Layout>

      <div className="container-fluid">

        <div className="d-flex justify-content-between align-items-center mb-4">

          <div>

            <h1
              style={{
                fontWeight: '800',
                color: '#0f172a'
              }}
            >
              Students Management
            </h1>

            <p
              style={{
                color: '#64748b'
              }}
            >
              Manage all students from one place
            </p>

          </div>

        </div>

        {/* FORM CARD */}

        <div
          className="card p-4 mb-4"
          style={{
            borderRadius: '24px'
          }}
        >

          <h4 className="mb-4">

            {isEditing ? (
              <>
                <FaEdit /> Edit Student
              </>
            ) : (
              <>
                <FaPlus /> Add Student
              </>
            )}

          </h4>

          <div className="row">

            {!isEditing && (

              <div className="col-md-3 mb-3">

                <input
                  className="form-control"
                  placeholder="Parent ID"
                  value={parentId}
                  onChange={(e) =>
                    setParentId(e.target.value)
                  }
                />

              </div>

            )}

            <div className="col-md-3 mb-3">

              <input
                className="form-control"
                placeholder="Student Name"
                value={studentName}
                onChange={(e) =>
                  setStudentName(e.target.value)
                }
              />

            </div>

            <div className="col-md-3 mb-3">

              <input
                className="form-control"
                placeholder="Class"
                value={className}
                onChange={(e) =>
                  setClassName(e.target.value)
                }
              />

            </div>

            <div className="col-md-3 mb-3">

              <input
                className="form-control"
                placeholder="Section"
                value={sectionName}
                onChange={(e) =>
                  setSectionName(e.target.value)
                }
              />

            </div>

          </div>

          {isEditing ? (

            <>
              <button
                className="btn btn-success"
                onClick={updateStudent}
              >
                Update Student
              </button>

              <button
                className="btn btn-secondary mt-2"
                onClick={clearForm}
              >
                Cancel
              </button>
            </>

          ) : (

            <button
              className="btn btn-primary"
              onClick={addStudent}
            >
              Add Student
            </button>

          )}

        </div>

        {/* TABLE CARD */}

        <div
          className="card p-4"
          style={{
            borderRadius: '24px'
          }}
        >

          <div className="d-flex justify-content-between align-items-center mb-4">

            <h4>
              <FaUserGraduate /> Students List
            </h4>

            <button
              className="btn btn-success"
              onClick={exportToExcel}
            >
              <FaFileExcel /> Export Excel
            </button>

          </div>

          <div className="input-group mb-4">

            <span className="input-group-text">
              <FaSearch />
            </span>

            <input
              className="form-control"
              placeholder="Search student name..."
              value={search}
              onChange={(e) =>
                setSearch(e.target.value)
              }
            />

          </div>

          <div className="table-responsive">

            <table
              className="table align-middle"
            >

              <thead>

                <tr
                  style={{
                    background:
                      '#eef2ff'
                  }}
                >

                  <th>ID</th>
                  <th>Name</th>
                  <th>Class</th>
                  <th>Section</th>
                  <th width="180">
                    Actions
                  </th>

                </tr>

              </thead>

              <tbody>

                {students
                  .filter((student) =>
                    student.student_name
                      .toLowerCase()
                      .includes(
                        search.toLowerCase()
                      )
                  )
                  .map((student) => (

                    <tr key={student.id}>

                      <td>
                        {student.id}
                      </td>

                      <td>
                        {student.student_name}
                      </td>

                      <td>
                        {student.class_name}
                      </td>

                      <td>
                        {student.section_name}
                      </td>

                      <td>

                        <button
                          className="btn btn-warning btn-sm"
                          onClick={() =>
                            editStudent(student)
                          }
                        >
                          <FaEdit />
                        </button>

                        <button
                          className="btn btn-danger btn-sm ms-2"
                          onClick={() =>
                            deleteStudent(
                              student.id
                            )
                          }
                        >
                          <FaTrash />
                        </button>

                      </td>

                    </tr>

                  ))}

              </tbody>

            </table>

          </div>

        </div>

      </div>

    </Layout>

  );

}

export default Students;